import React from "react";
import { Container, Row, Col } from "react-bootstrap";

var Api_url = process.env.GATSBY_API_URL;
var url = Api_url + `/api/wm/yearwise/team/members/lists`;
console.log('API_URL=' + Api_url + ', url=' + url);

var image1 = Api_url + `/assets/website/images/app_store.png`;
console.log('image1=' + image1);

const LoadingContent = () => {
    return (
        <div className="footer-widget mb-40 footer-widget__blog">
            <h3 className="footer-widget__title">Download iOS app</h3>
            <a href="https://apps.apple.com/in/app/jci-india-official-directory/id1579165277" target="_blank">
                <img src={image1} alt="" width="300px" />
            </a>
        </div>
    );
};

export default LoadingContent;
